const apiUrl = process.env.REACT_APP_API_URL;

export function getUserProfileImageURL(userId) {
  return `${apiUrl}/users/${userId}/image?timestamp=${new Date().getTime()}`;
}
export function getUserProfilenewsImageURL(newsId) {
  return `${apiUrl}/news/${newsId}/image?timestamp=${new Date().getTime()}`;
}

export function exportCSV(csvHeaders = [], data = [], fileName = "") {
  const csvRows = data.map((item) =>
    csvHeaders.map((field) => `${item[field]}`)
  );

  const csvContent = csvHeaders + "\n" + csvRows.join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", fileName);
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function formatDuration(nb_heursR) {
  let payload = {};

  if (nb_heursR < 60) {
    payload.value = nb_heursR;
    payload.type = "seconds";
  } else if (nb_heursR >= 60 && nb_heursR < 3600) {
    const minutes = Math.floor(nb_heursR / 60);
    payload.value = minutes;
    payload.type = "minutes";
  } else if (nb_heursR >= 3600) {
    const hours = Math.floor(nb_heursR / 3600);
    payload.value = hours;
    payload.type = "hours";
  }

  return payload;
}
